<template>
  <div>
    <a-descriptions bordered size="small" title="专项信息" :column="6">
      <a-descriptions-item label="重要分类">{{ model.importanceType }}</a-descriptions-item>
      <a-descriptions-item label="是否核心设备">{{ model.ifkernel }}</a-descriptions-item>
      <a-descriptions-item label="专项类型">{{ model.specialTypeName }}</a-descriptions-item>
      <a-descriptions-item label="是否环保设备" :span="3">{{ model.ifenvionmental }}</a-descriptions-item>
      <a-descriptions-item label="是否保密设备" :span="3">{{ model.ifsecurity }}</a-descriptions-item>
    </a-descriptions>
    <a-descriptions bordered size="small" title="出厂信息" :column="6">
      <a-descriptions-item label="生产厂家">{{ model.manufactureFactory }}</a-descriptions-item>
      <a-descriptions-item label="出厂日期">{{ model.dateInProduced }}</a-descriptions-item>
      <a-descriptions-item label="出厂编号">{{ model.factoryNumber }}</a-descriptions-item>
      <a-descriptions-item label="供应技术资料说明" :span="3">{{ model.instructionBook }}</a-descriptions-item>
      <a-descriptions-item label="入库日期">{{ model.arrivalDate}}</a-descriptions-item>
      <a-descriptions-item label="购置日期">{{ model.purchaseDate}}</a-descriptions-item>
      <a-descriptions-item label="到货日期">{{ model.deloveryDate}}</a-descriptions-item>
      <a-descriptions-item label="生产日期">{{ model.producedDate}}</a-descriptions-item>
      <a-descriptions-item label="出库日期">{{ model.outboundDeliveryDate}}</a-descriptions-item>
      <a-descriptions-item label="拨交日期">{{ model.dateOfDelivery}}</a-descriptions-item>
      <a-descriptions-item label="报废日期">{{ model.retirementDate}}</a-descriptions-item>
      <a-descriptions-item label="资本化日期">{{ model.capitalizationDate}}</a-descriptions-item>
      <a-descriptions-item label="投用日期">{{ model.entryDate}}</a-descriptions-item>
      <a-descriptions-item label="维保合同到期">{{ model.maintenanceDate}}</a-descriptions-item>
      <a-descriptions-item label="注册代码">{{ model.registerCode }}</a-descriptions-item>
      <a-descriptions-item label="使用登记证号">{{ model.certificateNumber }}</a-descriptions-item>
      <a-descriptions-item label="全国检验报告编号">{{ model.inspectionReportNumber }}</a-descriptions-item>
      <a-descriptions-item label="外观质量">{{ model.quality }}</a-descriptions-item>
      <a-descriptions-item label="特种设备类型">{{ model.specialEquipmentType }}</a-descriptions-item>
      <a-descriptions-item label="是否校准/定检">{{ model.ifverify }}</a-descriptions-item>
    </a-descriptions>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (model) {
        console.log('watch_record', model)
        this.initDetail(model)
      },
      immediate: true
    }
  },
  data () {
    return {
      detail: {}
    }
  },
  methods: {
    initDetail (model) {
      this.model.dateInProduced = model.dateInProduced ? moment(model.dateInProduced).format('YYYY-MM-DD') : ''
      this.model.arrivalDate = model.arrivalDate ? moment(model.arrivalDate).format('YYYY-MM-DD') : ''
      this.model.purchaseDate = model.purchaseDate ? moment(model.purchaseDate).format('YYYY-MM-DD') : ''
      this.model.deloveryDate = model.deloveryDate ? moment(model.deloveryDate).format('YYYY-MM-DD') : ''
      this.model.producedDate = model.producedDate ? moment(model.producedDate).format('YYYY-MM-DD') : ''
      this.model.outboundDeliveryDate = model.outboundDeliveryDate ? moment(model.outboundDeliveryDate).format('YYYY-MM-DD') : ''
      this.model.dateOfDelivery = model.dateOfDelivery ? moment(model.dateOfDelivery).format('YYYY-MM-DD') : ''
      this.model.retirementDate = model.retirementDate ? moment(model.retirementDate).format('YYYY-MM-DD') : ''
      this.model.capitalizationDate = model.capitalizationDate ? moment(model.capitalizationDate).format('YYYY-MM-DD') : ''
      this.model.entryDate = model.entryDate ? moment(model.entryDate).format('YYYY-MM-DD') : ''
      this.model.maintenanceDate = model.maintenanceDate ? moment(model.maintenanceDate).format('YYYY-MM-DD') : ''
    }
  }
}
</script>
<style scoped>
</style>